import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function Pagination({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) {
  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let page = 1; page <= totalPages; page += 1) {
        pages.push(page);
      }

      return pages;
    }

    pages.push(1);

    if (currentPage > 4) {
      pages.push("left-ellipsis");
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (currentPage < totalPages - 3) {
      pages.push("right-ellipsis");
    }

    pages.push(totalPages);

    return pages;
  };

  return (
    <div className="mt-6 flex flex-col gap-4 rounded-2xl border border-red-100 bg-red-50/40 px-5 py-4 md:flex-row md:items-center md:justify-between">
      <p className="text-sm text-gray-600">
        Showing <span className="font-semibold text-red-900">{startItem}</span>
        {" – "}
        <span className="font-semibold text-red-900">{endItem}</span>
        {" of "}
        <span className="font-semibold text-red-900">{totalItems}</span>{" "}
        employees
      </p>

      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="inline-flex items-center gap-2 rounded-xl border border-red-200 bg-white px-4 py-2.5 text-sm font-semibold text-red-800 transition hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400 disabled:hover:bg-white"
        >
          <FiChevronLeft />
          Previous
        </button>

        {getPageNumbers().map((page) =>
          typeof page === "number" ? (
            <button
              key={page}
              type="button"
              onClick={() => onPageChange(page)}
              className={`flex h-10 w-10 items-center justify-center rounded-xl text-sm font-semibold transition ${
                currentPage === page
                  ? "bg-red-800 text-white shadow-md shadow-red-900/20"
                  : "border border-red-200 bg-white text-red-800 hover:border-red-300 hover:bg-red-50"
              }`}
            >
              {page}
            </button>
          ) : (
            <span
              key={page}
              className="flex h-10 w-8 items-center justify-center text-sm font-bold text-red-400"
            >
              …
            </span>
          ),
        )}

        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="inline-flex items-center gap-2 rounded-xl border border-red-200 bg-white px-4 py-2.5 text-sm font-semibold text-red-800 transition hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400 disabled:hover:bg-white"
        >
          Next
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
}
